import { useSelector, } from 'react-redux';
import { useEffect, } from 'react';
import { actionFetchTabs, useAppDispatch, IReducerStore, } from '@Store';

let initiated = false;

export const useTabs = (autoload: boolean = true) => {
  const dispatch = useAppDispatch();
  const tabs = useSelector((store: IReducerStore) => store.tabs);

  useEffect(() => {
    if (!initiated && autoload && !tabs.loaded && !tabs.loading) {
      initiated = true;
      dispatch(actionFetchTabs());
    }
  }, [autoload, tabs.loaded, tabs.loading, dispatch, ]);

  return tabs;
};
